// NATIVE

// INSTALLED

// CUSTOM
import { Grid, IconButton, Tooltip } from '@mui/material';
import InputField from '../../formFields/InputField';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';
import { useSelector } from 'react-redux';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import CheckboxField from '../../formFields/checkBoxField';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

export const CrearExpressCheckin = (props: any) => {
  const {
    formField: { code, adults, minors, arrival, departure, bussines },
  } = props;

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <InputField
            name={code.name}
            label={code.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <InputNumeric
            name={adults.name}
            label={adults.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <InputNumeric
            name={minors.name}
            label={minors.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <DatePickerField label={arrival.label} name={arrival.name} />
        </Grid>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <DatePickerField label={departure.label} name={departure.name} />
        </Grid>
      </Grid>

      <Grid size={{ xs: 4 }}>
        <div
          style={{ display: 'flex', flexDirection: 'row', lineHeight: 0, justifyContent: 'end' }}
        >
          <CheckboxField name={bussines.name} label={bussines.label} />
          <Tooltip title="Si la reserva es para empresas con un unico codigo se pueden registrar la cantidad de personas que se indico en adultos mostrando un unico formulario por persona.">
            <IconButton>
              <HelpOutlineOutlinedIcon color="primary" />
            </IconButton>
          </Tooltip>
        </div>
      </Grid>
    </div>
  );
};
